/**
 * Phone number formatting utilities
 */

/**
 * Format a phone number to (XXX) XXX-XXXX format
 * @param {string} phone - Raw phone number
 * @returns {string} Formatted phone number
 */
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Handle different lengths
  if (cleaned.length === 0) return '';
  
  // If starts with 1 (country code), remove it
  const digits = cleaned.startsWith('1') && cleaned.length === 11 
    ? cleaned.slice(1) 
    : cleaned;
  
  // Format based on length
  if (digits.length <= 3) {
    return `(${digits}`;
  } else if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  } else {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  }
};

/**
 * Format phone number as user types (for input fields)
 * @param {string} value - Current input value
 * @returns {string} Formatted phone number
 */
export const formatPhoneInput = (value) => {
  if (!value) return '';
  
  // Remove all non-digit characters
  const cleaned = value.replace(/\D/g, '');
  
  // Limit to 10 digits
  const digits = cleaned.slice(0, 10);
  
  // Format based on length
  if (digits.length === 0) return '';
  if (digits.length <= 3) {
    return `(${digits}`;
  } else if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  } else {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
};

/**
 * Get raw digits from formatted phone number (for API calls)
 * @param {string} phone - Formatted phone number
 * @returns {string} Raw digits only
 */
export const getPhoneDigits = (phone) => {
  if (!phone) return '';
  return phone.replace(/\D/g, '');
};

/**
 * Generate tel: link for phone number
 * @param {string} phone - Phone number
 * @returns {string} tel: link
 */
export const getPhoneLink = (phone) => {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  return `tel:+1${digits}`;
};
